import React from "react";
import "./Footer.css";
const Footer = () => {
  return (
    <footer className="mt-5 text-center py-3 fs-5 ">
      <p className="fw-bold">Trending Movies App</p>
      <p className="copyright">
        Made With <i className="fa-solid fa-heart"></i> | All Rights Resrved
      </p>
    </footer>
  );
};

export default Footer;
